import React from 'react';
import PropertyNotes from '../../common/Notes/';

const Notes = (props) => {
  return <PropertyNotes companyId={props.companyId} propertyId={props.propertyId} />;
};

export default Notes;
